export class CustomerTokenItem {
	customerKey: string;
	token: string;

	type: number;
	postalCode: string;
	firstUseVenueKey: number;
	lastUseVenueKey: number;
	firstUseDateTime: string;
	lastUseDateTime: string;
	useCount: number;
	useRevenue: number;
	cardNumber: string;
	displayName: string;
	typeDisplayObject: {
		name: string;
		number: number;
		faIcon: string;
	};

	public constructor(init?: Partial<CustomerTokenItem>) {
		Object.assign(this, init);
	}
}
